
module dgUtils {

    function dashesToCamel(): IStringTransformFilter {
        return (str) => {
            return str.replace(/\W+(.)/g, function (x, chr) {
                return chr.toUpperCase();
            });
        }
    }
    angular.module('dgUtils')
        .filter('dashesToCamel', dashesToCamel);
}